import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { debounce, throttle } from 'lodash';
import domReady from '../helpers/dom-ready';
import User from '../features/user-manager';

class UserMenu {
  static init() {
    return new UserMenu();
  }

  constructor() {
    this.userMenu = document.querySelector('.user-menu');

    if (this.userMenu) {
      this.userButton = this.userMenu.querySelector('.account-button');
      this.cartButton = this.userMenu.querySelector('.cart-button');
      this.modalWrapper = this.userMenu.querySelector('.modal-wrapper');
      this.background = this.userMenu.querySelector('.transparent-background');
      this.logoutButton = this.userMenu.querySelector('.logout-button');
      this.accountWrapper = this.modalWrapper.querySelector('.account');

      if (this.accountWrapper) {
        this.closeAccountButton = this.accountWrapper.querySelector('.close-button');
        this.getUserDetails();
      }

      this.addEventListeners();
    }
  }

  addEventListeners() {
    this.userButton.addEventListener('click', () => {
      this.userMenu.classList.add('-open');
      this.userMenu.classList.add('-account');
      disableBodyScroll(this.userMenu);
    });

    this.background.addEventListener('click', () => {
      this.userMenu.classList.remove('-open');
      if (this.userMenu.classList.contains('-account')) {
        this.userMenu.classList.remove('-account');
      }
      if (this.userMenu.classList.contains('-cart')) {
        this.userMenu.classList.remove('-cart');
      }
      enableBodyScroll(this.userMenu);
    });

    this.closeAccountButton.addEventListener('click', () => {
      this.userMenu.classList.remove('-open');
      this.userMenu.classList.remove('-account');
      enableBodyScroll(this.userMenu);
    });

    this.logoutButton.addEventListener('click', () => {
      User.logout();
    });

    window.addEventListener('scroll', throttle(() => {
      if (this.cartButton) this.toggleButtonPosition('cart');
      if (this.userButton) this.toggleButtonPosition('account');
    }), 50);

    window.addEventListener('resize', debounce(() => {
      if (this.cartButton) this.toggleButtonPosition('cart');
      if (this.userButton) this.toggleButtonPosition('account');
    }), 50);
  }

  toggleButtonPosition(type) {
    const scrollPosition = document.body.scrollTop;

    if (type === 'cart') {
      if (scrollPosition < 10 && !this.cartButton.classList.contains('-at-top')) {
        this.cartButton.classList.add('-at-top');
      } else if (scrollPosition >= 10 && this.cartButton.classList.contains('-at-top')) {
        this.cartButton.classList.remove('-at-top');
      }
    } else if (type === 'account') {
      if (scrollPosition < 10 && !this.userButton.classList.contains('-at-top')) {
        this.userButton.classList.add('-at-top');
      } else if (scrollPosition >= 10 && this.userButton.classList.contains('-at-top')) {
        this.userButton.classList.remove('-at-top');
      }
    }
  }

  onApproveTerms(wrapperEl) {
    document.body.removeChild(wrapperEl);
    User.agreeToTerms({ agreed_to_terms: 1 });
  }

  async getUserDetails() {
    const {
      // eslint-disable-next-line camelcase
      first_name, last_name, company, email, address, zipcode, city, country, agreed_to_terms,
    } = await User.getUserDetails();

    const accountInfo = this.modalWrapper.querySelector('.account .account-info');

    const userName = accountInfo.querySelector('.name');
    // eslint-disable-next-line camelcase
    userName.innerText = `${first_name} ${last_name}`;

    const userCompany = accountInfo.querySelector('.company');
    const userEmail = accountInfo.querySelector('.email');
    const userAddress = accountInfo.querySelector('.address');
    const userZipcode = accountInfo.querySelector('.zipcode');

    if (company) {
      userCompany.innerText = `${company}`;
    }
    if (email) {
      userEmail.innerText = `${email}`;
    }
    if (address) {
      userAddress.innerText = `${address}`;
    }
    if (zipcode) {
      userZipcode.innerText = `${zipcode}`;
    }
    if (city) {
      userZipcode.innerText += ` ${city},`;
    }
    if (country) {
      userZipcode.innerText += ` ${country}`;
    }
    // eslint-disable-next-line camelcase
    if (agreed_to_terms && agreed_to_terms === '0') {
      const {
        heading, text, linklabel, linkhref, buttonlabel,
      } = this.userMenu.dataset;
      if (heading && text && linklabel && linkhref && buttonlabel) {
        // Check that all values are set in admin
        if (linkhref === window.location.href) return;

        // Add popup before trying to move forward
        const wrapperEl = document.createElement('div');
        wrapperEl.classList.add('popup-wrapper');
        const popupEl = document.createElement('div');
        popupEl.classList.add('popup-container');

        // Heading
        const popupHeadingEl = document.createElement('h3');
        popupHeadingEl.innerText = heading;
        popupEl.appendChild(popupHeadingEl);

        // Text
        const popupTextEl = document.createElement('p');
        popupTextEl.innerText = `${text} `;
        popupEl.appendChild(popupTextEl);

        // Link
        const popupLinkEl = document.createElement('a');
        popupLinkEl.href = linkhref;
        popupLinkEl.innerText = linklabel;
        popupLinkEl.target = '_blank';
        popupTextEl.appendChild(popupLinkEl);

        // Button
        const popupButtonEl = document.createElement('button');
        popupButtonEl.innerText = buttonlabel;
        popupButtonEl.onclick = () => this.onApproveTerms(wrapperEl);
        popupButtonEl.type = 'button';
        popupButtonEl.classList.add('button');
        popupButtonEl.classList.add('-solid');
        popupEl.appendChild(popupButtonEl);

        // Append to body
        wrapperEl.appendChild(popupEl);
        document.body.appendChild(wrapperEl);
      }
    }
  }
}
domReady(() => {
  UserMenu.init();
});
